'use client';

import { useState } from 'react';

import { Button, ButtonVariant } from '@bytel/trilogy-react';

import { FaiProduct } from '@app-types/fai';
import { PlanType } from '@app-types/product';
import { TagEventType } from '@app-types/tracking';

import useTracking from '@hooks/use-tracking';

import { TagAnimated } from './home/bottom-content/animated-tag';

interface CtaAddToCartProps {
    selectedProduct?: FaiProduct | PlanType | null;
    temporarilySelectedProduct?: FaiProduct | PlanType | null;
    handleAddToCart: () => void;
    ctaLabel: {
        productAdded: string;
        productNotAdded: string;
        tagAdded: string;
    };
}

export function CtaAddToCart({
    selectedProduct,
    temporarilySelectedProduct,
    handleAddToCart,
    ctaLabel,
}: Readonly<CtaAddToCartProps>) {
    const [isTagVisible, setIsTagVisible] = useState(false);
    const { sendTag } = useTracking();

    const isSelectedProductFai = selectedProduct && 'gencode_offre' in selectedProduct;
    const isTemporarilySelectedProductFai = temporarilySelectedProduct && 'gencode_offre' in temporarilySelectedProduct;

    const productGencode = isSelectedProductFai ? selectedProduct?.gencode_offre : selectedProduct?.gencode;

    const temporarySelectedProductGencode = isTemporarilySelectedProductFai
        ? temporarilySelectedProduct?.gencode_offre
        : temporarilySelectedProduct?.gencode;

    const isProductAdded = productGencode === temporarySelectedProductGencode;

    return (
        <div className='cta-with-centered-tag'>
            <TagAnimated label={ctaLabel.tagAdded} isVisible={isTagVisible} />

            <Button
                variant={isProductAdded ? ButtonVariant.SECONDARY : ButtonVariant.PRIMARY}
                fullwidth
                onClick={() => {
                    handleAddToCart();
                    if (!isProductAdded) {
                        sendTag(
                            {
                                actionClic: 'Clic_redirection',
                                categorieClic: 'Ajouter_au_panier',
                                nomClic:
                                    (isTemporarilySelectedProductFai
                                        ? temporarilySelectedProduct.range_ng
                                        : temporarilySelectedProduct?.url) ?? '',
                            },
                            TagEventType.CLICK,
                        );
                        setIsTagVisible(true);
                        setTimeout(() => {
                            setIsTagVisible(false);
                        }, 1200);
                    }
                }}
                id='selectOffer'
            >
                {isProductAdded ? ctaLabel.productAdded : ctaLabel.productNotAdded}
            </Button>
        </div>
    );
}
